import React from 'react';
import { AlertCircle } from 'lucide-react';

export const Req = () => <span className="text-[#E5387B] ml-0.5" aria-hidden="true">*</span>;

export const InlineError = ({ msg, id }) => msg ? (
  <div className="mt-2 inline-flex items-center gap-1 bg-[#DC2626] text-white text-[12px] px-2 py-0.5 rounded-sm" role="alert" data-testid={`error-${id}`}><AlertCircle className="w-3 h-3" /> {msg}</div>
) : null;

export const Field = ({ id, label, required, error, children, hint }) => (
  <div id={`ob-${id}`} className={`py-3 px-3 rounded-sm ${error ? 'bg-[#DC2626]/10 ring-1 ring-[#DC2626]' : ''}`} data-testid={`ob-field-${id}`}>
    <label className="block text-[16px] text-white mb-1.5">{label}{required && <Req />}</label>
    {children}
    {hint && !error && <div className="text-[12px] text-white/70 mt-1">{hint}</div>}
    <InlineError msg={error} id={id} />
  </div>
);

export const inputCls = 'w-full h-[40px] px-3 text-[16px] text-[#2C3345] bg-white border border-[#B8BDC9] outline-none focus:border-[#0F766E] rounded-none';

export const TextInput = (props) => <input className={inputCls} {...props} />;

export const TermsBlock = ({ id, checked, onChange, error, label = 'Terms and Conditions' }) => (
  <div id={`ob-${id}`} className="bg-[#A9D3DE] text-[#1E2B3A] px-3 py-3 rounded-sm" data-testid={`ob-field-${id}`}>
    <div className="text-[15px] mb-3">{label}<Req /></div>
    <label className="flex items-start gap-2.5 cursor-pointer text-[14px] leading-snug">
      <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={`ob-checkbox-${id}`} className="mt-0.5 w-[18px] h-[18px] accent-[#0F766E] bg-white border border-[#93A1AE]" />
      <span className="text-[#5A6B7B]">I agree to use electronic records and signatures. <span className="text-[#DC2626]">*</span> <span className="text-[#DC2626] text-[11px] font-bold tracking-wide">REQUIRED</span></span>
    </label>
    <InlineError msg={error} id={id} />
  </div>
);

export const CaptchaBox = ({ challenge, value, onChange, error, onRefresh }) => (
  <div id="ob-captcha" className="py-3 px-3" data-testid="ob-field-captcha">
    <label className="block text-[16px] text-white mb-1.5">Please verify that you are human<Req /></label>
    <div className="inline-flex flex-wrap items-center gap-4 bg-[#F9F9F9] border border-[#D3D3D3] rounded-[3px] px-4 py-3 text-[#2C3345] shadow-sm max-w-full" style={{ minWidth: 'min(302px, 100%)' }}>
      <div>
        <div className="text-[14px]">{challenge?.question || 'Loading challenge…'}</div>
        <input value={value} onChange={(e) => onChange(e.target.value)} inputMode="numeric" data-testid="ob-captcha-answer" placeholder="Your answer" className="mt-1.5 w-[120px] h-[32px] px-2 text-[14px] border border-[#B8BDC9] rounded-[2px] outline-none focus:border-[#0F766E]" />
      </div>
      <div className="text-center text-[10px] text-[#555] leading-tight">
        <div className="w-8 h-8 mx-auto rounded-full border-4 border-[#1A73E8] border-r-[#34A853] border-b-[#FBBC05] border-l-[#EA4335]" />
        <div className="mt-1">Human check</div>
        <button type="button" onClick={onRefresh} className="underline text-[#1A73E8]" data-testid="ob-captcha-refresh">new one</button>
      </div>
    </div>
    <InlineError msg={error} id="captcha" />
  </div>
);
